import { IAppStoreConnectApiSetting, ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { AppStoreConnectApiSettings } from "./app-settings-config-app-store";

export interface IAppStoreConnectApiInputState {
  showModal: boolean;
  editingAppStoreConnectApiId: string;
}

export interface IAppStoreConnectApiInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class AppStoreConnectApiInput extends PureComponent<
  IAppStoreConnectApiInputProps,
  IAppStoreConnectApiInputState
> {
  formInputName = ["iosConfig", "appStoreConnectApiSettingsId"];

  constructor(props: IAppStoreConnectApiInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingAppStoreConnectApiId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingAppStoreConnectApiId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingAppStoreConnectApiId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = [
      { id: null, name: "Default" } as unknown as IAppStoreConnectApiSetting,
      ...(commonSettings.appStoreConnectApiSettings || [])
    ];
    return (
      <>
        <AppStoreConnectApiSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingAppStoreConnectApiId={this.state.editingAppStoreConnectApiId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Configuration"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey="ios_appstoresettings_configuration"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appStoreSettingsDropdown"
          addNewTestId="appStoreSettingsAddNewButton"
          editTestId="appStoreSettingsEditButton"
        />
      </>
    );
  }
}
